import { render, staticRenderFns } from "./TreatmentItemDetailInputPopup.vue?vue&type=template&id=e28dc86a&scoped=true&"
import script from "./TreatmentItemDetailInputPopup.vue?vue&type=script&lang=js&"
export * from "./TreatmentItemDetailInputPopup.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentItemDetailInputPopup.vue?vue&type=style&index=0&id=e28dc86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28dc86a",
  null
  
)

export default component.exports